import { Link } from 'react-router-dom';
import ArticleCard from '@/components/base/ArticleCard';
import { articles } from '@/mocks/articles';

export default function LatestPosts() {
  const latestArticles = articles.slice(0, 8);

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="flex flex-col lg:flex-row gap-8">
        <div className="flex-1">
          <div className="flex items-center justify-between mb-6">
            <div>
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
                最新帖子
              </h2>
              <p className="text-sm text-foreground-600 mt-1">社区最新发布的优质内容</p>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            {latestArticles.map((article) => (
              <ArticleCard key={article.id} article={article} variant="default" />
            ))}
          </div>
        </div>

        <aside className="w-full lg:w-[320px] flex-shrink-0">
          <div className="sticky top-20">
            <div className="p-5 rounded-xl bg-background-100/70 border border-background-200/70 mb-5">
              <h3 className="text-sm font-semibold text-foreground-900 mb-3 font-heading">社区公告</h3>
              <ul className="flex flex-col gap-2.5">
                <li>
                  <Link to="/article/article-12" className="text-sm text-foreground-700 hover:text-primary-600 transition-colors line-clamp-2">
                    给新人的论坛使用指南：快速融入一品楼社区的六个技巧
                  </Link>
                </li>
                <li>
                  <a href="#" className="text-sm text-foreground-700 hover:text-primary-600 transition-colors line-clamp-2">
                    2026年8月社区活动预告：读书打卡挑战赛正式开启
                  </a>
                </li>
                <li>
                  <a href="#" className="text-sm text-foreground-700 hover:text-primary-600 transition-colors line-clamp-2">
                    一品楼论坛新版积分规则说明及会员等级介绍
                  </a>
                </li>
              </ul>
            </div>

            <div className="p-5 rounded-xl bg-background-100/70 border border-background-200/70">
              <h3 className="text-sm font-semibold text-foreground-900 mb-3 font-heading">活跃用户</h3>
              <div className="flex flex-col gap-3">
                {[
                  { name: '技术达人小王', posts: '2.8k', avatar: articles[0].avatar },
                  { name: '理财小陈', posts: '1.9k', avatar: articles[1].avatar },
                  { name: '追剧小能手', posts: '1.7k', avatar: articles[7].avatar },
                  { name: '数码控阿杰', posts: '1.5k', avatar: articles[4].avatar },
                  { name: '码农老李', posts: '1.3k', avatar: articles[3].avatar },
                ].map((user, i) => (
                  <div key={i} className="flex items-center gap-3">
                    <img
                      src={user.avatar}
                      alt={user.name}
                      className="w-8 h-8 rounded-full object-cover"
                      width="32"
                      height="32"
                    />
                    <div className="flex-1 min-w-0">
                      <div className="text-sm font-medium text-foreground-800">{user.name}</div>
                      <div className="text-xs text-foreground-500">{user.posts} 帖子</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </aside>
      </div>
    </section>
  );
}